<template>
  <div class="HighchartsSizeConfiger">
    <p>
      图表宽高配置
    </p>
    <div class="flex-chart">
      <div class="WHsize">
        {{ propertyData[propertyDataKey].title1 }}
      </div>
      <div>
        <el-input @change="handleChange" v-model="ChartsStyle.width" placeholder="宽度"></el-input>
      </div>
      <div class="WHsize">
        {{ propertyData[propertyDataKey].title2 }}
      </div>
      <div>
        <el-input @change="handleChange" v-model="ChartsStyle.height" placeholder="高度"></el-input>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HighchartsSizeConfiger',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      ChartsWidth: 100,
      ChartsHeigth: 45,
      ChartsStyle: {
        width: 100,
        height: 45,
      },
    };
  },
  created() {
    this.ChartsStyle = this.$_.cloneDeep(this.propertyData[this.propertyDataKey].value);
  },
  methods: {
    handleChange(val) {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: { ...this.ChartsStyle },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.HighchartsSizeConfiger {
  width: 100%;
  margin: 10px 0;
  p {
    color: $property-title-color;
    font-size: 14px;
    padding: 0 15px;
  }
  .flex-chart {
    display: flex;
    justify-content: space-between;
    text-align: center;
    align-items: center;
    padding: 8px 12px;
  }
  .WHsize {
    color: #71717c;
    font-size: 12px;
    width: 50px;
  }

  .el-input {
    position: relative;
    font-size: 12px;
    display: inline !important;
    width: 100%;
    line-height: 28px;
  }
  :deep().el-input input {
    background-color: #191b23;
    border: 1px solid #5a5a5a;
    color: #fcfcfc;
    width: 60px;
    text-align: center;
    height: 28px;
    line-height: 28px;
    border-radius: 0;
    &:hover {
      border: 1px solid #3179ff;
    }
  }
}
</style>
